import { useSelector } from 'react-redux';

import { RootState } from 'store';

const useIsUserType = (type: string) =>
  useSelector((state: RootState) => state?.user?.accountResult)?.type.toLowerCase() === type.toLowerCase() ?? false;

export default useIsUserType;
